import React from "react";
import styles from "./item-no-with-copy.module.css";
import { CopyToClipboardButton } from "@coworker/app/src/components/RoomSettings/Atoms/CopyToClipboardButton";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";

export const ItemNoWithCopy = ({ itemNo }: { itemNo: string }) => {
  return (
    <div className={styles["item-no-container"]}>
      <ItemNo itemNo={itemNo} />
      <CopyToClipboardButton
        valueForClipboard={itemNo.replace(/\./g, "")}
        onClick={() => {}}
      />
    </div>
  );
};
